import React from 'react';

import './styles.scss';

const MenuSeparator = ({ isMobileMenu }) => (
  <div className={` outer-border-menu mt-2 ${isMobileMenu && 'mb-3'}`}>
    <div className="border-menu" />
  </div>
);

export default MenuSeparator;
